/* eslint-disable import/prefer-default-export */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import styles from '../tab-states.module.css';

interface TabStatesWithComponentProps {
    tabs: {
        name: string;
        callBack: (value: number) => void;
    }[];
    /** Index of the selected tab, for callers that own the selection state. */
    currentTab?: number;
    withMargin?: boolean;
    children: React.ReactNode;
}

export const TabStatesWithComponent: React.FC<TabStatesWithComponentProps> = ({
    tabs,
    currentTab = 0,
    withMargin = true,
    children,
}) => {
    const [currentView, setCurrentView] = React.useState<number>(currentTab);

    React.useEffect(() => {
        setCurrentView(currentTab);
    }, [currentTab]);

    const setView = (index: number, callBack: (value) => void): void => {
        if (currentView !== index) {
            setCurrentView(index);
            callBack(index);
        }
    };

    return (
        <div className={`${styles.TabStates} ${styles.WithComponent} ${!withMargin ? styles.NoMargin : ''}`}>
            <div className={styles.TabStatesRow}>
                {tabs.map(({ name, callBack }, index) => (
                    <h2
                        className={currentView === index ? styles.TabStatesActiveTab : styles.TabStatesInactiveTab}
                        onClick={() => setView(index, callBack)}
                        key={`tab-state-${name}`}
                        data-qa={`tab-state-component-${name}`}
                    >
                        {name}
                    </h2>
                ))}
            </div>
            <div>{children}</div>
        </div>
    );
};
